// Premium product gallery: mouse drag-to-swipe + position dot indicators.
// Works together with Dawn's native <slider-component> / <media-gallery>.
(function () {
  function initGallery(mediaGallery) {
    const viewer = mediaGallery.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!viewer) return;

    const track = viewer.querySelector('.product__media-list.slider');
    const dotsWrap = viewer.querySelector('.gallery-dots');
    if (!track) return;

    // --- Mouse drag-to-swipe ---
    let isDown = false;
    let dragged = false;
    let startX = 0;
    let startScrollLeft = 0;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') return;
      isDown = true;
      dragged = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', (event) => {
      if (!isDown || event.pointerType !== 'mouse') return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 3) dragged = true;
      if (!dragged) return;
      event.preventDefault();
      track.scrollLeft = startScrollLeft - delta;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      if (dragged) {
        // snap to nearest slide after a free drag
        const items = Array.from(track.querySelectorAll('.slider__slide')).filter(
          (el) => el.clientWidth > 0
        );
        if (items.length) {
          let closest = items[0];
          let closestDistance = Infinity;
          items.forEach((item) => {
            const distance = Math.abs(item.offsetLeft - track.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closest = item;
            }
          });
          track.scrollTo({ left: closest.offsetLeft, behavior: 'smooth' });
        }
        // Swallow the click that follows a drag so it doesn't open the zoom modal.
        const suppressClick = (clickEvent) => {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
        };
        track.addEventListener('click', suppressClick, { capture: true, once: true });
        setTimeout(() => track.removeEventListener('click', suppressClick, { capture: true }), 300);
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // --- Dot indicators ---
    if (dotsWrap) {
      const dots = Array.from(dotsWrap.querySelectorAll('.gallery-dots__dot'));
      const slides = Array.from(track.querySelectorAll('.slider__slide'));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.dotIndex, 10);
          const target = slides[index];
          if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
      });

      const setActiveDot = (index) => {
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };

      viewer.addEventListener('slideChanged', (event) => {
        const currentPage = event.detail && event.detail.currentPage;
        if (currentPage) setActiveDot(currentPage - 1);
      });

      // Keep dots in sync when the active media changes via thumbnails/variant swaps.
      const observer = new MutationObserver(() => {
        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (activeIndex > -1) setActiveDot(activeIndex);
      });
      slides.forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['class'] }));
    }
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Dawn swaps product-info content (variant change triggering a new gallery).
  document.addEventListener('product-info:loaded', (event) => {
    const gallery = event.target.querySelector ? event.target.querySelector('media-gallery') : null;
    if (gallery) initGallery(gallery);
  });
})();
